module.exports = __webpack_public_path__ + "img/balance-budget.b0b673a2.svg";